import { formatNumber } from "../utils/utils";
import { greenArrow, redArrow, equalSign, CircleArrowUp, CircleArrowDown, CircleEqual } from "./Icons";
import useLocale from "../hooks/useLocale";

const locale = useLocale();

export default function Variation({ value }) {

    let variation;

    if (value > 0) {
        variation = "up";
    }

    if (value < 0) {
        variation = "down";
    }

    if (value === 0) {
        variation = "none";
    }

    return (
        <div className="variation">
            {variation === "up" && greenArrow}
            {variation === "down" && redArrow}
            {variation === "none" && equalSign}

            <p className={`small-text --variation-${variation || ""}`}>
            {formatNumber(value, locale, 2)}
            {value && "%"}
            </p>
        </div>
    );
}

export function VariationBig({ value }) {
    let variation;

    if (value > 0) {
        variation = "up";
    }

    if (value < 0) {
        variation = "down";
    }

    if (value === 0) {
        variation = "none";
    }

    return (
        <div className="variation-big">
            {variation === "up" && <CircleArrowUp />}
            {variation === "down" && <CircleArrowDown />}
            {variation === "none" && <CircleEqual />}

            <p className={`title-4 --variation-${variation || ""}`}>
                {/* {variation === "up" ? "+" : variation === "down" ? "-" : "="} */}
                {formatNumber(value, locale, 2)}%
            </p>
        </div>
    );
}
